import fetchApi from 'services/api/connector';

/**
 * Manual vulnerability grouping endpoints (Backend):
 * POST /_api/v3/ws/<workspace_name>/vulns/group/create
 * POST /_api/v3/ws/<workspace_name>/vulns/group/add
 * POST /_api/v3/ws/<workspace_name>/vulns/group/remove
 * DELETE /_api/v3/ws/<workspace_name>/vulns/group/<id>
 * POST /_api/v3/ws/<workspace_name>/vulns/group/rename
 *
 * Bodies:
 * - create: { group_title: string, vuln_ids: number[] }
 * - add:    { group_id: number, vuln_ids: number[] }
 * - remove: { vuln_ids: number[] }
 * - delete: empty body (id in path)
 * - rename: { group_id: number, new_title: string }
 */

const base = (workspace) => `ws/${workspace}/vulns/group`;

export const createManualGroup = (workspace, { groupIds, groupTitle }) => {
  const data = { group_title: groupTitle, vuln_ids: groupIds };
  return fetchApi(`${base(workspace)}/create`, { method: 'POST', data, version: 'v3' });
};

export const addToManualGroup = (workspace, { groupHeader, groupIds }) => {
  const data = { group_id: groupHeader, vuln_ids: groupIds };
  return fetchApi(`${base(workspace)}/add`, { method: 'POST', data, version: 'v3' });
};

export const removeFromManualGroup = (workspace, { groupIds }) => {
  const data = { vuln_ids: groupIds };
  return fetchApi(`${base(workspace)}/remove`, { method: 'POST', data, version: 'v3' });
};

export const deleteManualGroups = (workspace, { groupsIds }) => {
  const groupId = Array.isArray(groupsIds) ? groupsIds[0] : groupsIds;
  return fetchApi(`${base(workspace)}/${groupId}`, { method: 'DELETE', version: 'v3' });
};

export const renameManualGroup = (workspace, { groupHeaderId, newTitle }) => {
  const data = { group_id: groupHeaderId, new_title: newTitle };
  return fetchApi(`${base(workspace)}/rename`, { method: 'POST', data, version: 'v3' });
};

export const showGroupHosts = (workspace, {
  groupId,
  page,
  pageSize
} = {}) => {
  const params = {};

  if (groupId !== null && typeof groupId !== 'undefined') {
    params.group_id = groupId;
  }
  if (Number.isFinite(page) && page >= 1) {
    params.page = Math.trunc(page);
  }
  if (Number.isFinite(pageSize) && pageSize >= 1) {
    params.page_size = Math.trunc(pageSize);
  }

  return fetchApi(`ws/${workspace}/hosts`, { method: 'GET', params: Object.keys(params).length ? params : undefined, version: 'v3' });
};

const mockGroupServicesResponse = {
  services: [
    {
      id: 1,
      key: 1,
      value: {
        _id: 1,
        id: 1,
        name: 'epmap',
        summary: '(135/tcp) epmap',
        protocol: 'tcp',
        ports: 135,
        status: 'open',
        vulns: 1,
        type: 'Service'
      }
    },
    {
      id: 2,
      key: 2,
      value: {
        _id: 2,
        id: 2,
        name: 'http',
        summary: '(80/tcp) http',
        protocol: 'tcp',
        ports: 80,
        status: 'open',
        vulns: 1,
        type: 'Service'
      }
    },
    {
      id: 3,
      key: 3,
      value: {
        _id: 3,
        id: 3,
        name: 'ssh',
        summary: '(22/tcp) ssh',
        protocol: 'tcp',
        ports: 22,
        status: 'open',
        vulns: 1,
        type: 'Service'
      }
    }
  ],
  count: 3
};

export const showGroupServices = async (workspace, {
  groupId,
  page,
  pageSize
} = {}) => {
  const params = {};

  if (groupId !== null && typeof groupId !== 'undefined') {
    params.group_id = groupId;
  }
  if (Number.isFinite(page) && page >= 1) {
    params.page = Math.trunc(page);
  }
  if (Number.isFinite(pageSize) && pageSize >= 1) {
    params.page_size = Math.trunc(pageSize);
  }

  try {
    return await fetchApi(`ws/${workspace}/services`, { method: 'GET', params: Object.keys(params).length ? params : undefined, version: 'v3' });
  } catch (e) {
    return mockGroupServicesResponse;
  }
};
